export default {
  'component.orderlist.title': 'Bestillingsoversikt',
};
